import { render, staticRenderFns } from "./DetailBaseInfo.vue?vue&type=template&id=c8662f30&scoped=true&"
import script from "./DetailBaseInfo.vue?vue&type=script&lang=js&"
export * from "./DetailBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailBaseInfo.vue?vue&type=style&index=0&id=c8662f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8662f30",
  null
  
)

export default component.exports